import { defineComponent as _defineComponent } from 'vue'
import MyProjectsWatchlist from '@/views/my-projects/components/MyProjectsWatchlist.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsCreatedAndWatched',
  setup(__props) {

const {
  loadMyProjects
} = useMyProjects();

loadMyProjects();

return { __sfc: true,loadMyProjects, MyProjectsWatchlist }
}

})